import React from 'react';
import {Row, Col} from 'react-bootstrap';
import {connect} from 'react-redux';
import {getPersonalTraining} from '../actions/ProAction';
import {TrainingTables, EmptyPT} from '../components/Pro.Training.Tables';
import Spinner from '../components/Spinner';
import {pageView} from '../util/tracking';

class Training extends React.Component{

  constructor(){
    super();
    this.state={
      ptSessions: []
    };
  }

  componentWillMount(){
    if(!this.props.ptSessions){
      this.props.getPersonalTraining(this.props.courseId);
    }
    pageView();
  }

  render(){
    let {userState, ptSessions} = this.props;

    return(
      <Row className="training_table_row pro_row">
        <Col xs={12} md={10} mdOffset={1}>
          {ptSessions?
            ptSessions.length>0?
              <TrainingTables ptSessions={ptSessions} />:
              <EmptyPT userState={userState}/>
            :<Spinner />
          }
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => {
  return{
    courseId: state.auth.courseId,
    ptSessions: state.pro.ptSessions,
    userState: state.auth.userState
  };
};

const mapDispatchToProps = (dispatch) => {
  return{
    getPersonalTraining: (courseId)=>{
      dispatch(getPersonalTraining(courseId));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Training);



// WEBPACK FOOTER //
// ./src/containers/Pro.Training.js